import { useComponentEntry } from '@utils/component-framework';
import { useOpgavekompleksetComponent } from './context.data.js';
import { makeSelectCurrentTaskEntry } from './selectors/entry.get-current-task.js';

function useOpgavekompleksetEntry(extraConfig) {
  const component = useOpgavekompleksetComponent();
  return useComponentEntry(component.entryKey, extraConfig).data;
}
function selectCurrentTaskEntryId(component, entry) {
  const currentTaskIdFromEntry = entry?.activeTaskId;
  if (currentTaskIdFromEntry && component.tasks.some(it => it.id === currentTaskIdFromEntry)) {
    return currentTaskIdFromEntry;
  }
  return component.tasks[0]?.id;
}
function useCurrentTaskEntryId() {
  const component = useOpgavekompleksetComponent();
  return useOpgavekompleksetEntry({
    select: entry => selectCurrentTaskEntryId(component.data, entry?.data)
  }) ?? "";
}
function useCurrentTaskEntry(args) {
  const component = useOpgavekompleksetComponent();
  return useOpgavekompleksetEntry({
    // @ts-expect-error args.select should be allowed to influence output
    select: entry => {
      const taskEntry = makeSelectCurrentTaskEntry(component.data)(entry?.data);
      return args?.select ? args.select(taskEntry) : taskEntry;
    }
  });
}

export { selectCurrentTaskEntryId, useCurrentTaskEntry, useCurrentTaskEntryId, useOpgavekompleksetEntry };
//# sourceMappingURL=hook.entry.js.map
